import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { api } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import EmptyState from '../components/EmptyState';

export default function Usuarios() {
  const { temPermissao } = useAuth();
  const podeEditar = temPermissao('usuarios_editar');
  const [usuarios, setUsuarios] = useState([]);
  const [perfis, setPerfis] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [carregando, setCarregando] = useState(true);

  const carregar = async () => {
    setCarregando(true);
    try {
      const [u, p] = await Promise.all([api.get('/usuarios'), api.get('/perfis')]);
      setUsuarios(u.data);
      setPerfis(p.data);
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.error || 'Falha ao carregar', confirmButtonColor: '#2e9846' });
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => { carregar(); }, []);

  const vincular = async (u) => {
    const opcoes = perfis.reduce((acc, p) => { acc[p.id] = p.nome; return acc; }, {});
    const { value: perfilId } = await Swal.fire({
      title: u.perfil_id ? `Alterar perfil de ${u.nome}` : `Vincular ${u.nome}`,
      input: 'select',
      inputOptions: opcoes,
      inputValue: u.perfil_id || '',
      inputPlaceholder: 'Selecione um perfil',
      showCancelButton: true,
      confirmButtonColor: '#2e9846',
      inputValidator: (v) => !v && 'Escolha um perfil',
    });
    if (!perfilId) return;
    try {
      await api.put(`/usuarios/${u.id}/vinculo`, { perfil_id: parseInt(perfilId, 10) });
      carregar();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.error || 'Falha', confirmButtonColor: '#2e9846' });
    }
  };

  const desvincular = async (u) => {
    const r = await Swal.fire({
      icon: 'warning',
      title: `Desvincular ${u.nome}?`,
      text: 'O usuário perde o acesso ao portal-clientes (continua existindo no Centrão).',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Desvincular',
    });
    if (!r.isConfirmed) return;
    try {
      await api.delete(`/usuarios/${u.id}/vinculo`);
      carregar();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.error || 'Falha', confirmButtonColor: '#2e9846' });
    }
  };

  const lista = usuarios.filter(u =>
    !filtro || u.nome?.toLowerCase().includes(filtro.toLowerCase())
  );

  return (
    <>
      <div className="page-header-cli">
        <h1 className="page-title-cli"><i className="bi bi-person-badge"></i> Usuários</h1>
        <input
          className="input-cli"
          placeholder="Buscar por nome…"
          value={filtro}
          onChange={(e) => setFiltro(e.target.value)}
          style={{ maxWidth: 260 }}
        />
      </div>

      {carregando ? (
        <div className="card-cli">Carregando…</div>
      ) : lista.length === 0 ? (
        <EmptyState icon="bi-people" titulo="Nenhum usuário encontrado" />
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table className="tabela-cli">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Status</th>
                <th>Perfil no portal</th>
                {podeEditar && <th style={{ width: 220 }}>Ações</th>}
              </tr>
            </thead>
            <tbody>
              {lista.map((u) => (
                <tr key={u.id}>
                  <td>{u.nome}</td>
                  <td>
                    <span className={'tag-cli ' + (u.active ? '' : 'cinza')}>
                      {u.active ? 'Ativo' : 'Inativo'}
                    </span>
                  </td>
                  <td>
                    {u.perfil_nome
                      ? <span className="tag-cli laranja">{u.perfil_nome}</span>
                      : <span className="tag-cli cinza">Não vinculado</span>}
                  </td>
                  {podeEditar && (
                    <td>
                      <div className="acoes-row-cli">
                        <button className="btn-ghost-cli" onClick={() => vincular(u)}>
                          <i className="bi bi-pencil"></i> {u.perfil_id ? 'Alterar' : 'Vincular'}
                        </button>
                        {u.perfil_id && (
                          <button className="btn-ghost-cli" onClick={() => desvincular(u)}>
                            <i className="bi bi-x-circle"></i> Desvincular
                          </button>
                        )}
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
